import React from 'react'
import PropTypes from "prop-types";

export default function Alert(prop) {
    const capitalize = (word)=>{
        const lower = word.toLowerCase();
        return lower.charAt(0).toUpperCase()+lower.slice(1);
    }
  return (
    prop.alert && <div className={`alert alert-${prop.alert.type} alert-dismissible fade show`} role="alert">
   {capitalize(prop.alert.type)}:{prop.alert.msg}
    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  </div>
  )
}
